import { SEO } from "@/components/SEO";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const guides = [
  {
    slug: "boiler-replacement-cost-uk",
    title: "Boiler Replacement Cost UK (2024)",
    description: "Average prices for combi, system and conventional boiler installs, plus what affects the final quote.",
    priceRange: "£1,800 – £4,500",
  },
];

export const CostGuidesIndex = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <SEO
        title="UK Tradesman Cost Guides 2024 — Average Prices | Sortable"
        description="Up-to-date UK cost guides for common tradesman jobs. Compare average prices, factors that affect cost, and how to get the best quote near you."
        keywords="tradesman cost guide uk, cost of, average price uk, home repair costs, near me, quote"
        canonical="https://sortable.uk/blog/cost-guides"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "UK Tradesman Cost Guides",
          "url": "https://sortable.uk/blog/cost-guides",
        }}
      />
      <main className="container mx-auto px-4 py-12 max-w-5xl">
        <header className="mb-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">UK Tradesman Cost Guides</h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real-world price ranges for common home repair and improvement jobs across the UK — so you know what a fair quote looks like before you book a tradesman.
          </p>
        </header>
        <div className="grid gap-6 md:grid-cols-2">
          {guides.map((g) => (
            <Link key={g.slug} to={`/blog/cost-guides/${g.slug}`} className="group">
              <Card className="h-full transition-shadow hover:shadow-lg">
                <CardHeader>
                  <CardTitle className="group-hover:text-primary flex items-center justify-between">
                    {g.title}
                    <ArrowRight className="h-5 w-5" />
                  </CardTitle>
                  <CardDescription>{g.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-sm font-medium">Typical cost: <span className="text-primary">{g.priceRange}</span></p>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default CostGuidesIndex;
